import { ColumnElement, ColumnTitle } from '@atoms/columnElement';
import { InfoTooltip } from '@atoms/infoTooltip';
import { SwitchV2 } from '@atoms/switch';
import { TraceWidthSelector } from '@atoms/traceWidthSelector/traceWidthSelector';
import { Column } from '@components/dnd/base/blockBase/body.block.style';
import { Input } from '@components/ui/input';
import { Label } from '@components/ui/label';
import type { ColumnData, TraceWidth } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';
import type { PropsWithChildren } from 'react';

type Props = PropsWithChildren<
  ColumnData & {
    onWidthChange: (width: TraceWidth) => void;
    onTitleChange: (title: string) => void;
    onFixedColumnChange: (isfixedColumn: boolean) => void;
    onDisplayByDefaultChange: (displayByDefault: boolean) => void;
    atomId: string;
  }
>;

export const ColumnComp = observer((props: Props) => (
  <>
    {props.children}

    <Column $width="220px">
      <ColumnTitle htmlFor={`title-${props.atomId}`}>
        Column options
      </ColumnTitle>
      <ColumnElement>
        <Label htmlFor={`title-${props.atomId}`}>Column header</Label>
        <Input
          id={`title-${props.atomId}`}
          onChange={e => props.onTitleChange(e.target.value)}
          placeholder="Aa"
          value={props.title}
        />
      </ColumnElement>
      <ColumnElement>
        <TraceWidthSelector
          id={props.atomId}
          label="Column width"
          onWidthChange={props.onWidthChange}
          selectedWidth={props.width}
        />
      </ColumnElement>
      <ColumnElement>
        <SwitchV2
          checked={props.isDisplayedByDefault}
          id={`display-by-default-${props.atomId}`}
          labelText="Displayed by default"
          onCheckedChange={props.onDisplayByDefaultChange}
          tooltip={
            <InfoTooltip
              description="Whether the column is displayed by default or if the user needs to activate it."
              title="Displayed by default"
            />
          }
        />
      </ColumnElement>
      <ColumnElement>
        <SwitchV2
          checked={props.isfixedColumn}
          id={`fixed-column-${props.atomId}`}
          labelText="Fixed column"
          onCheckedChange={props.onFixedColumnChange}
          tooltip={
            <InfoTooltip
              description="Whether the column is always visible if the table is scrolled horizontally."
              title="Fixed column"
            />
          }
        />
      </ColumnElement>
    </Column>
  </>
));
